export function sanitizeHtml(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Tags permitidas
    const allowedTags = new Set([
        "DIV",
        "P",
        "SPAN",
        "STRONG",
        "B",
        "I",
        "EM",
        "U",
        "BR",
        "UL",
        "OL",
        "LI",
        "H1",
        "H2",
        "H3",
        "H4",
        "H5",
        "H6",
        "BLOCKQUOTE",
        "CODE",
        "PRE",
        "A",
        "IMG",
    ]);

    // Atributos permitidos
    const allowedAttributes: Record<string, string[]> = {
        A: ["href", "title", "target"],
        IMG: ["src", "alt", "title"],
        "*": ["class"],
    };

    function clean(node: HTMLElement | Element) {
        // Percorrer filhos primeiro
        [...node.children].forEach((child) => {
            const tagName = child.tagName;

            // Remover tags não permitidas
            if (!allowedTags.has(tagName)) {
                child.remove();
                return;
            }

            // Remover atributos perigosos
            [...child.attributes].forEach((attr) => {
                const name = attr.name.toLowerCase();


                const allowed =
                    allowedAttributes[tagName]?.includes(attr.name) || allowedAttributes["*"]?.includes(attr.name);

                // Remove eventos (onclick, onerror, etc)
                if (name.startsWith("on")) {
                    child.removeAttribute(attr.name);
                    return;
                }

                // Remove javascript: urls
                if (["href", "src"].includes(name) && attr.value.trim().toLowerCase().startsWith("javascript:")) {
                    child.removeAttribute(attr.name);
                    return;
                }

                // Remove atributos não permitidos
                if (!allowed) {
                    child.removeAttribute(attr.name);
                }
            });

            clean(child);
        });
    }

    clean(doc.body);

    return doc.body.innerHTML;
}
